import { Outlet } from 'react-router-dom';
import { ConditionalHeader } from './layout/ConditionalHeader';
import { Footer } from './layout/Footer';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[rgb(var(--background))]">
      <ConditionalHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}